import {Steps} from "@app/pages/auth/Signup/type"
import {Path} from "@app/route_path"
import { useLocation, useNavigate } from "react-router-dom";
import { useFormWithSchema } from "@app/components/forms/hooks/useFormWithSchema";
import { useEffect, Fragment } from "react";
import FormContainer from "@app/components/forms/container/FormContainer";
import { Button } from "@shortsworks/ui";
import { PlatformSchema } from "@app/pages/auth/Signup/platformSchema";
import { PlatformType } from "@app/types/platform";

// cafe24 로 가입 진행되는 경우 shopList 또한 location 에서 받아옴
export const PlatformInfoForm = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { form, schemas, parseForm, setFormValues } = useFormWithSchema({
    formSchemas: PlatformSchema({
      platformType: location.state.platformType,
      shopList: location.state.shopList,
    }),
    mode: "onChange",
  });

  useEffect(() => {
    if (!location.state?.platformType) {
      return;
    }
    setFormValues({
      platformType: location.state.platformType,
    });
  }, []);

  const goPrevious = () => {
    return navigate([Path.SIGNUP, Steps.STEP2].join("/"), {
      state: {
        ...location.state,
        [Steps.PATH]: Steps.STEP2,
      },
    });
  };

  const goNext = () => {
    const parsedForm = parseForm();

    if (!parsedForm.success) {
      return;
    }

    const { platformType, platformKeyMAKESHOP, platformKeyFLEXG } =
      parsedForm.data;

    const targetPath =
      location.state.platformType === PlatformType.BLOGPAY
        ? "/signup/blogpay"
        : "/signup/step4";

    return navigate(targetPath, {
      state: {
        ...location.state,
        ...parsedForm.data,
        signupStep: "step4",
        ...(platformType === PlatformType.MAKESHOP && {
          platformKey: platformKeyMAKESHOP,
        }),
        ...(platformType === PlatformType.FLEXG && {
          platformKey: platformKeyFLEXG,
        }),
      },
    });
  };

  return (
    <Fragment>
      <h1 className="text-xl font-bold">회원 가입</h1>
      <FormContainer schemas={schemas} form={form} />
      <div className="flex flex-row w-full">
        <Button
          className="w-full mr-4"
          variant="secondary"
          onClick={goPrevious}
        >
          이전
        </Button>
        <Button className="w-full" onClick={goNext}>
          다음
        </Button>
      </div>
    </Fragment>
  );
};
